import React, { useRef } from 'react';
import { InputQ1Wrapper, InputLabel } from '../styles';
import DatePicker from 'components/Input/datepicker/Datepicker';
import utils from 'utils';
import actions from 'state/actions';
import { UserDate } from 'models/user';
import { FieldInputType } from 'models/response';

interface DateInputProps {
  field: any;
  helpers: any;
  multi?: boolean;
  index?: number;
  label: string;
  readonly: boolean;
  feedbackColor: string;
  hasFeedback: boolean;
  feedbackMessage: string;
  dateFormat: UserDate;
  triggerConfig: any;
  executeActionQ1: () => void;
  autoViewInPage: () => void;
  dispatch: any;
  fieldInputType: FieldInputType;
  name: string;
  onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  icon: JSX.Element;
}

export const DateInput: React.FC<DateInputProps> = ({
  field,
  helpers,
  multi,
  index,
  label,
  readonly,
  feedbackColor,
  hasFeedback,
  feedbackMessage,
  dateFormat,
  triggerConfig,
  executeActionQ1,
  autoViewInPage,
  dispatch,
  fieldInputType,
  name,
  onKeyDown,
  icon
}) => {
  const inputRef = useRef<any>();

  const dateValue: Date | null =
    multi && (index || index === 0)
      ? field.value.content[index].content
        ? utils.date.convertToObjectDate(field.value.content[index].content)
        : null
      : field.value.content[0].content
      ? utils.date.convertToObjectDate(field.value.content[0].content)
      : null;

  const handleDateChange = (date: Date | null) => {
    if (field.value) {
      const formatDate = date ? utils.date.formatDateForDb(date) : '';
      const arrayValues = [...field.value.content];
      arrayValues[multi && (index || index === 0) ? index : 0] = {
        ...field.value.content[multi && (index || index === 0) ? index : 0],
        content: formatDate,
        status: 0,
      };
      helpers.setValue({
        ...field.value,
        content: arrayValues,
      });
      if (triggerConfig) executeActionQ1();
    }
  };

  const handleDateBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length && field.value) {
      const date: Date | undefined = inputRef.current?.state?.preSelection;
      const formatDate = date && date instanceof Date ? utils.date.formatDateForDb(date) : '';
      const arrayValues = [...field.value.content];
      arrayValues[multi && (index || index === 0) ? index : 0] = {
        ...field.value.content[multi && (index || index === 0) ? index : 0],
        content: formatDate,
        status: 3,
      };
      helpers.setValue({
        ...field.value,
        content: arrayValues,
      });
    }
  };

  const onFocus = () => {
    autoViewInPage();
    field.value && dispatch(actions.documents.setFocussedQ1({ fieldInputType, name, multi, index }));
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Tab') inputRef.current.setOpen(false);
    onKeyDown(e);
  };

  return (
    <>
      <InputQ1Wrapper multi={multi} margin="0 0 0 -4px">
        <InputLabel title={label}>{!multi ? label : ''}</InputLabel>
        <DatePicker
          feedbackColor={feedbackColor}
          hasFeedback={hasFeedback}
          feedbackMessage={feedbackMessage}
          ref={inputRef}
          onBlur={handleDateBlur}
          selected={dateValue}
          dateFormat={dateFormat}
          disabled={readonly}
          onFocus={onFocus}
          onChange={handleDateChange}
          portal
          shouldCloseOnSelect={false}
          onKeyDown={handleKeyDown}
          inputWidth={multi ? '160px' : '200px'}
        />
      </InputQ1Wrapper>
      {icon}
    </>
  );
};
